export { FrequentlyAskedQuestions } from "./FrequentlyAskedQuestions"
